export default {

  SET_AGORA_RADIO(state, content) {
    state.agoraRadio = content
  },
  SETBUILDERINFO(state, content) {
    state.builder = content
  },
  SETCURRENTINFO(state, content) {
    state.current = content
  },
  SET_REDE_SOCIAL(state, content) {
    state.redeSocial = content
  },
  SET_SITE_CONTENT(state, content){
    state.siteContent = content
  },
  SET_BLOCOS(state, content){
    state.blocos = content
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js